import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { Checkbox, CheckboxSubLabel } from 'components/common/CheckboxV2/Checkbox';
import { getTestId } from 'utils/testing';

export const CheckboxFacet = (props: Extract<FacetComponentProps, { type: 'checkbox' }>) => {
  const { label, count, isSelected, onClick, testId } = props;
  return (
    <Checkbox checked={isSelected} onClick={onClick} className="py-0" data-test-id={getTestId(testId)} label={label}>
      <CheckboxSubLabel className="body-xs ml-auto text-gray-500">{`(${count})`}</CheckboxSubLabel>
    </Checkbox>
  );
};
